import React from "react";
import Loading from "../../../../common/components/Loading";
import UserRegisterContextProvider, { ACTIONS, UserRegisterContext } from "../../context/UserRegisterContextProvider"
import UserRegister from "../UserRegister";
import PersonalInfo from "../PersonalInfo";
import {decode_utf8} from "../../../../common/utils/utilsFunc"

const ControllerUserRegister = ({ props }) => {
    const [state, dispatch] = React.useContext(UserRegisterContext)
    const [loading, setLoading] = React.useState(false);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [formFirstPage, setFormFirstPage] = React.useState();
    const [formSecondPage, setFormSecondPage] = React.useState();
    const [optionsRegion, setOptionsRegion] = React.useState([{label: "Selecione una opción",value: ""}]);
    const [setError, setErrorMsg] = React.useState();
    const [optionsComunaRegion, setOptionsComunaRegion] = React.useState([{ label: "Selecione una region", value: 0 }]);
    const [optionsRelationsSelect, setOptionsRelationsSelect] = React.useState([{ label: "Seleccione una opción", value: "", }]);
    
    React.useEffect(() => {
        if(formFirstPage || formSecondPage) {
            localStorage.setItem("state",JSON.stringify({formFirstPage:formFirstPage,formSecondPage:formSecondPage,currentPage:currentPage}));
        }
    },[formFirstPage,formSecondPage,currentPage]);

    React.useEffect(() => {
        if(localStorage?.getItem("state") !== "undefined") {

            const storedState = JSON.parse(localStorage?.getItem("state"));
            
            if(storedState?.formFirstPage) {
                setFormFirstPage(storedState?.formFirstPage);
            }
            if(storedState?.formSecondPage) {
                let auxStorage = storedState?.formSecondPage;
                auxStorage.region = storedState?.formSecondPage.region?Number(storedState?.formSecondPage.region):0
                auxStorage.comuna = storedState?.formSecondPage.comuna?Number(storedState?.formSecondPage.comuna):0
                
                setFormSecondPage(auxStorage);
            }
            if(storedState?.currentPage) {
                setCurrentPage(storedState?.currentPage);
            }
        }

    },[]);

    React.useEffect(() => {
        if(state.allRegion){
            setLoading(false);
            if(state.allRegion.code === 0){
                let regions = [];
                state.allRegion?.regions.forEach((item) => {
                    regions.push({ label: item.nomeRegion, value: Number(item.regionId) })
                });  
                setOptionsRegion([...optionsRegion, ...regions])  
            } else {
                setError(true);
                state.allRegion?.message ? setErrorMsg(state.allRegion?.message) : setErrorMsg(decode_utf8(props.text_fetch_error))
            }
        }
    
      }, [state.allRegion])
    
      
    React.useEffect(() => {
        if(formSecondPage?.region){
            setLoading(true)
            dispatch({ 
                type:ACTIONS.SET_ID_REGION,
                payload:formSecondPage?.region
            })
        } else {
            setOptionsComunaRegion([{ label: "Selecione una region", value: 0 }]);
        }
    }, [formSecondPage?.region]);

    React.useEffect(() => {
        if(state.comunaRegion){
          setLoading(false);
          if(state.comunaRegion.code === 0){
            let comunas = [];
            state.comunaRegion?.comunas.forEach((item) => {
              comunas.push({ label: item.nomComuna, value: Number(item.codigoSAP) })
            });
            setOptionsComunaRegion([{ label: "Selecione una opción", value: 0 },...comunas]);
          } else {
            props.setGlobalAlert(state.comunaRegion?.message ? state.comunaRegion?.message : props.text_fetch_error, "warning", true, "Advertencia")
            
          }
        }
      }, [state.comunaRegion]);

      React.useEffect(() => {
        if(state?.relations) {
            let auxArrRelation = [{
                label: "Seleccione una opción",
                value: "",
            }];
            state.relations.map((obj,i) => {
                auxArrRelation.push({ label:obj, value: obj});
            });
            setOptionsRelationsSelect(auxArrRelation);
        }
    },[state.relations]);

    React.useEffect(() => {
        if(state?.idClientVerifyResponse) {
            setLoading(false);
            
            const {idClientVerifyResponse} = state;

            if(idClientVerifyResponse?.data?.status === 200)
                setCurrentPage(2);
            else
                props.setGlobalAlert(idClientVerifyResponse?.data?.msg, "warning", true, "Advertencia");
        }
    },[state.idClientVerifyResponse]);
    
    function setResetFormAux() {
        setFormFirstPage();
        setFormSecondPage();
        setCurrentPage(1);
        localStorage.setItem("state",JSON.stringify());
        dispatch({ 
            type:ACTIONS.SET_FORM_RESPONSE,
            payload:null
        })
        
    }

    const [optionsPrefixCell, setOptionsPrefixCell] = React.useState([])

    React.useEffect(() => {
        setLoading(true);

        if(props?.list_DDD_cellphone) {
        const auxStr = props?.list_DDD_cellphone.replaceAll("[","").replaceAll("]","");
        const auxAr = auxStr.split(",");
        let auxAr2 = [];
        auxAr.map((obj) => {
            auxAr2.push({label:obj,value:obj})
        })
        setOptionsPrefixCell(auxAr2);
        }
        
    },[])
    
    return (
        <>
            {currentPage === 1 && 
                <UserRegister props={ props } state={ state } setCurrentPage={setCurrentPage} form={formSecondPage} setForm={setFormSecondPage} optionsRelationsSelect={optionsRelationsSelect} setLoadingReal={setLoading} ACTIONS={ACTIONS} dispatch={ dispatch } />
            }
            {currentPage === 2 && 
                <PersonalInfo props={ props } state={ state } ACTIONS={ACTIONS} dispatch={ dispatch } setCurrentPage={setCurrentPage} form={formSecondPage} setForm={setFormSecondPage} setResetForm={setResetFormAux} optionsRegion={optionsRegion} optionsComunaRegion={optionsComunaRegion} optionsPrefixCell={optionsPrefixCell} />
            }
            {loading && <Loading />}
        </>
    );
};

const ControllerUserRegisterWithProvider = ({
    props

}) => (
    <UserRegisterContextProvider>
        <ControllerUserRegister
            props={props}
        />
    </UserRegisterContextProvider>
);

export default ControllerUserRegisterWithProvider;
